// extracted by mini-css-extract-plugin
module.exports = {"container":"_3G4wQV16cgqC45osru_bbn","content":"_3Agq2TX5_Z6PuyJT7AQ9c1","footer":"_3RpRmePtGEtXPLGQWuutcT","headerFixed":"_2oFBN_XphcYhfd6t_fkJy9"};